import { Container } from '@components/Container'
import { Tabs } from '@components/Tabs/Tabs'
import { ProfileHeader } from '@features/profile/components/ProfileHeader'
import { SHOW_EBOOK_FEATURE } from '@configs/config'
import { WritingTab } from './components/WritingTab'
import { PenNameTab } from './components/PenNameTab'
import { RewardTab } from './components/RewardTab'
import { EbookTab } from './components/EbookTab'
import { ProfilePageProps } from './interface'
import { BookListTab } from './components/BookListTab'

export function ProfilePage({
  user,
  isProfileOwner,
  handleFollow,
  handleActiveTabChange,
  slug,
}: ProfilePageProps) {
  return (
    <Container className='mobile:px-[20px] desktop-tablet:pt-[30px] desktop-tablet:pb-[80px]'>
      <ProfileHeader
        userId={user.id}
        profilePageSlug={slug}
        bannerImgPath={user.bannerImgPath}
        avatarImgPath={user.avatarImgPath}
        displayName={user.displayName}
        username={user.username}
        aboutMe={user.aboutMe}
        facebookLink={user.facebookLink}
        twitterLink={user.twitterLink}
        totalFollowing={user.totalFollowing}
        totalFollower={user.totalFollower}
        totalWriting={user.totalBook}
        totalBookmark={user.totalBookshelf}
        totalReading={user.totalRead}
        isFollowed={user.isFollowed}
        canFollow={isProfileOwner}
        canChat={isProfileOwner}
        onFollow={handleFollow}
        isAdmin={user.isAdmin}
        allowSendMessage={user.allowSendMessage}
        email={user.email}
      />
      <Tabs
        id='profile'
        initialTabs={
          SHOW_EBOOK_FEATURE
            ? [
                {
                  tabId: 'writing',
                  name: 'งานเขียน (0)',
                  dataTest: 'writing-tab',
                },
                { tabId: 'ebook', name: 'อีบุ๊ก (0)', dataTest: 'ebook-tab' },
                {
                  tabId: 'penName',
                  name: 'นามปากกา (0)',
                  dataTest: 'pen-name-tab',
                },
                { tabId: 'reward', name: 'รางวัล' },
                { tabId: 'bookList', name: 'ลิสต์หนังสือ' },
              ]
            : [
                {
                  tabId: 'writing',
                  name: 'งานเขียน (0)',
                  dataTest: 'writing-tab',
                },
                {
                  tabId: 'penName',
                  name: 'นามปากกา (0)',
                  dataTest: 'pen-name-tab',
                },
                { tabId: 'reward', name: 'รางวัล' },
                { tabId: 'bookList', name: 'ลิสต์หนังสือ' },
              ]
        }
        onActiveTabChange={handleActiveTabChange}
      >
        <WritingTab userId={user.id} />
        {SHOW_EBOOK_FEATURE && <EbookTab userId={user.id} />}
        <PenNameTab userId={user.id} />
        <RewardTab userId={user.id} />
        <BookListTab userId={user.id} />
      </Tabs>
    </Container>
  )
}
